/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Audio_Chat_InsteadInputs */



/**
* | output |
* | --- |
* | "Practise in chat instead" |
*
* @param {Practice_Session_Audio_Chat_InsteadInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_audio_chat_instead = /** @type {((inputs?: Practice_Session_Audio_Chat_InsteadInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Audio_Chat_InsteadInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Oefen via chat")
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'entraîner par chat")
	return /** @type {LocalizedString} */ ("Practise in chat instead")
});